import { InjectionToken } from "@angular/core";

export const TERMS_OF_USE_URL = new InjectionToken<string>("Terms of use url");
export const ACCESSIBILITY_STATEMENT_URL = new InjectionToken<string>("Accessibility statement url");
export const PANSA_UTM_URL = new InjectionToken<string>("PansaUTM url");
